jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

/**** Main menu ****/

$(".dropdown-toggle").dropdown();

function checkWidth() {
  if ($(window).width() < 975) {
    $(".navi li ul").hide();
  } else {
    $(".navi li ul").attr("style", "");
  }
}

checkWidth();

$(window).on("resize", function () {
  checkWidth();
  $("a.colapse").hide();
  $("a.expand").show();
});

$(".navi li").each(function () {
  var li = $(this);
  if (li.find("ul li").length > 0) {
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='expand icon-expand' onclick='return false;'></a>"
    );
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='colapse icon-collapse' onclick='return false;'></a>"
    );
  }
});

$("body").on("click", "a.expand", function () {
  $(this).hide().next().show();
  $(this).parent().siblings().find("ul").slideUp();
  $(this).parent().siblings().find("a.expand").show();
  $(this).parent().siblings().find("a.colapse").hide();
  $(this)
    .parent()
    .find(">ul")
    .addClass("expanded")
    .stop(true, true)
    .slideDown();
});

$("body").on("click", "a.colapse", function () {
  $(this)
    .parent()
    .find("ul")
    .removeClass("expanded")
    .stop(true, true)
    .slideUp();
  $(this).parent().find("a.colapse").hide();
  $(this).parent().find("a.expand").show();
});

$(".hamburger").on("click", function () {
  $(".hamburger").toggleClass("is-active");
  $(".header-container").toggleClass("navi-open");
  $(".navigation-wrapper").toggleClass("navi-open");
  $("body").toggleClass("navi-open");
});

$(".show-more").on("click", function () {
  $(this).closest("li.level1").find("ul.level2").toggle();
  $(this).closest("li.level1").toggleClass("open");
});
/**** Main menu end ****/

document.addEventListener("DOMContentLoaded", function () {
  if ($(".seminars-splide").length > 0) {
    var seminarsSlider = new Splide(".seminars-splide", {
      drag: false,
      pagination: false,
      arrows: true,
      fixedWidth: "340px",
      gap: "24px",
      breakpoints: {
        767: {
          fixedWidth: "300px",
        },
      },
    });

    seminarsSlider.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if ($(".employees-splide").length > 0) {
    var employeesSplide = new Splide(".employees-splide", {
      drag: false,
      pagination: false,
      arrows: true,
      fixedWidth: "340px",
      gap: "24px",
      breakpoints: {
        767: {
          fixedWidth: "300px",
        },
      },
    });

    employeesSplide.mount();
  }
});

$("#open-lang").on("click", function () {
  $(".lang-dropdown").toggleClass("open");
  $(this).toggleClass("open");
});

$(
  ".btn-primary, .btn-secondary, .btn-transparent, a.contact, a.kontakt, .buttons .btn"
).each(function () {
  var $btn = $(this);
  var $span = $btn.find("span").first();

  var originalText = $span.length
    ? $span.text().trim()
    : $btn
        .contents()
        .filter(function () {
          return this.nodeType === 3;
        })
        .text()
        .trim();

  if (originalText) {
    var wrappedHTML =
      '<div class="slide-in-bottom"><span data-hover="' +
      originalText +
      '">' +
      originalText +
      "</span></div>";

    if ($span.length) {
      $span.replaceWith(wrappedHTML);
    } else {
      $btn.html(wrappedHTML);
    }
  }
});

$(".video-wrapper").on("click", ".video-thumbnail, .icon-play", function () {
  var container = $(this).closest(".video-wrapper");
  var videoId = container.find(".video-thumbnail").data("video-id");

  var iframe =
    '<div class="youtube-video">' +
    '<iframe width="558" height="369" src="https://www.youtube.com/embed/' +
    videoId +
    '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>' +
    "</div>";

  container.html(iframe);
});
